import script from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"

import "./ProportionalWithdrawalInput.vue?vue&type=style&index=0&id=55bc23e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55bc23e2"]])

export default __exports__